<template>
  <div class="pb-6">
    <field-label :field="field"></field-label>

    <v-data-table
      class="pages-table"
      flat
      :headers="headers"
      :items="items"
      disable-sorting
      :hide-default-footer="items.length <= 10"
    >
      <template v-slot:top>
        <v-dialog v-model="dialog" scrollable max-width="800">
          <template v-slot:activator="{ on }">
            <v-btn color="success" dark v-on="on" depressed small
              >New item</v-btn
            >
          </template>

          <v-card>
            <v-card-title class="py-2">
              <span class="title">{{ formTitle }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pt-8">
              <v-form v-model="valid">
                <component
                  v-for="(field, index) in field.fields"
                  :is="`${field.type}-field`"
                  :key="index"
                  :field="field"
                  :value.sync="formData[index]"
                ></component>
              </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="py-1">
              <v-spacer></v-spacer>
              <v-btn color="success" text :disabled="!valid" @click="saveItem"
                >Apply changes</v-btn
              >

              <v-btn color="error" text @click="closeDialog">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item="{ item, index }">
        <tr>
          <td
            :class="`text-${column.align}`"
            v-for="column in headers.filter(v => v.value !== 'controls')"
            :key="column.value"
          >
            <v-img
              v-if="column.type == 'media-manager'"
              :src="loadMedia(item[column.value], 'thumbnail')"
              width="150"
              class="my-2"
            ></v-img>

            <span v-else>
              {{ item[column.value] }}
            </span>
          </td>
          <td class="text-right">
            <v-btn icon small color="accent" @click="editItem(index)">
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>

            <v-btn icon small color="error" @click="deleteItem(index)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'RepeatableField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  data: () => ({
    valid: false,
    dialog: false,
    itemIndex: -1,
    items: [],
    formData: {}
  }),
  computed: {
    formTitle() {
      return this.itemIndex === -1 ? 'New item' : 'Edit item'
    },
    headers() {
      let headers = Object.entries(this.field.fields)
        .filter(([key, item]) => !item.hideOnList)
        .map(([key, item]) => {
          return {
            text: item.label,
            sortable: false,
            align: 'left',
            value: key,
            type: item.type
          }
        })

      headers.push({
        text: 'Controls',
        sortable: false,
        align: 'right',
        value: 'controls'
      })

      return headers
    }
  },
  watch: {
    dialog(value) {
      value || this.closeDialog()
    },
    items: {
      deep: true,
      immediate: true,
      handler() {
        this.input(JSON.stringify(this.items))
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler() {
        if (this.value) {
          this.items = JSON.parse(this.value)
        }
      }
    }
  },
  methods: {
    resetFormData() {
      Object.keys(this.field.fields).forEach(key => {
        this.$set(this.formData, key, '')
      })
    },
    input(value) {
      this.$emit('update:value', value)
    },
    editItem(index) {
      this.dialog = true
      this.itemIndex = index
      Object.assign(this.formData, this.items[this.itemIndex])
    },
    deleteItem(index) {
      swal({
        title: 'Are you sure?',
        text: 'You will not be able to revert this.',
        type: 'warning',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          this.items.splice(index, 1)
        }
      })
    },
    closeDialog() {
      this.formData = {}
      this.dialog = false
      this.valid = true
      this.itemIndex = -1
    },
    saveItem() {
      if (this.itemIndex > -1) {
        Object.assign(this.items[this.itemIndex], this.formData)
      } else {
        this.items.push(this.formData)
      }

      this.closeDialog()
    }
  },
  mounted() {
    this.resetFormData()
  }
}
</script>
